import { LinkedAttr } from "@type-r/models/lib/model/linked-attrs";
import { Flex, SmallTile } from "lqx-react";
import * as React from "react";
import { InvoiceLandingSummary } from "../../api/invoices";
import { ChipWithLoading } from "../../common";
import { ApprovedInvoices } from "./approved-invoices";
import { SentOutInvoices } from "./sent-out-invoices";
import { SentOutSOA } from "./sent-out-soa";

export const ReviewTiles = ({ $category, $model }: { $category: LinkedAttr<string>, $model: InvoiceLandingSummary }) => {

    return (
        <>
            <SmallTile
                color="red"
                $selected={$category.equals('invoices-sent-out')}
                right={<ChipWithLoading model={$model.sentOutInvoices} color={'red'} />}
                footer="Invoices that were sent out via InBlock"
            >
                Invoices Sent Out
            </SmallTile>

            <SmallTile
                color="yellow"
                $selected={$category.equals('soa-sent-out')}
                right={<ChipWithLoading model={$model.sentOutSoa} />}
                footer="SOAs that were sent out vie InBlock"
            >
                Statement of Account Sent Out
            </SmallTile>

            <SmallTile
                color="yellow"
                $selected={$category.equals('invoices-approved')}
                right={<ChipWithLoading model={$model.approvedInvoices} />}
                footer="Invoices that have been approved by customer"
            >
                Approved Invoices
            </SmallTile>
        </>
    )
}

export const ReviewDetails = ({ category, state }: { category: string, state: InvoiceLandingSummary }) =>
    category === "invoices-approved" ? <ApprovedInvoices state={state.approvedInvoices} />
        : category === 'invoices-sent-out' ? <SentOutInvoices state={state.sentOutInvoices} />
            : category === 'soa-sent-out' ? <SentOutSOA state={state.sentOutSoa} />
                : <Flex center> <h2>Select the category on the left</h2> </Flex>
